import * as React from 'react';

export const getContainerHOC = <T extends {}, P extends {}>(Container: React.ComponentType<T>) => (Component: React.ComponentType<P>, childProps?: T) => {
	const ChildComponent = Component as React.ComponentType;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const ContainerHOC = (props: any) => (
		<Container {...props} {...childProps}>
			<ChildComponent/>
		</Container>
	);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ContainerHOC.fetchData = (Container as any).fetchData;

	return ContainerHOC;
};